module.exports = __webpack_public_path__ + "static/Dao-28775992459aa18265258d2b948eb720.jpg";